/* stylelint-disable */
import { baseSpacing, colors, radius } from 'css/constants';
import xmark from '@fortawesome/fontawesome-pro/svgs/regular/xmark.svg';

const ToastrStyles = `
  .animated {
    animation-duration: 1s;
    animation-fill-mode: both;
    &.bounceIn {
      animation-duration: .7s;
    }
    &.bounceOut {
      animation-duration: .5s;
    }
    &.bounceIn {
      animation-name: bounceIn;
    }
    &.bounceOut {
      animation-name: bounceOut;
    }
    &.fadeIn {
      animation-name: fadeIn;
      animation-duration: .7s;
    }
    &.fadeOut {
      animation-name: fadeOut;
      animation-duration: .3s;
    }
    &.bounceInDown {
      animation-name: bounceInDown;
    }
    &.bounceOutUp {
      animation-name: bounceOutUp;
    }
  }

  @keyframes bounceIn {
    from,20%,40%,60%,80%,to {
      animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    }

    0% {
      opacity: 0;
      transform: perspective(1px) scale3d(0.3, 0.3, 0.3);
    }

    20% {
      transform: perspective(1px) scale3d(1.1, 1.1, 1.1);
    }

    40% {
      transform: perspective(1px) scale3d(0.9, 0.9, 0.9);
    }

    60% {
      opacity: 1;
      transform: perspective(1px) scale3d(1.03, 1.03, 1.03);
    }

    80% {
      transform: perspective(1px) scale3d(0.97, 0.97, 0.97);
    }

    to {
      opacity: 1;
      transform: perspective(1px) scale3d(1, 1, 1);
    }
  }

  @keyframes bounceOut {
    20% {
      transform: scale3d(0.9, 0.9, 0.9);
    }

    50%,55% {
      opacity: 1;
      transform: scale3d(1.1, 1.1, 1.1);
    }

    to {
      opacity: 0;
      transform: scale3d(0.3, 0.3, 0.3);
    }
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  }

  @keyframes fadeOut {
    from {
      opacity: 1;
    }

    to {
      opacity: 0;
    }
  }

  @keyframes bounceInDown {
    from,60%,75%,90%,to {
      animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    }

    0% {
      opacity: 0;
      transform: translate3d(0, -3000px, 0);
    }

    60% {
      opacity: 1;
      transform: translate3d(0, 25px, 0);
    }

    75% {
      transform: translate3d(0, -10px, 0);
    }

    90% {
      transform: translate3d(0, 5px, 0);
    }

    to {
      transform: none;
    }
  }

  @keyframes bounceOutUp {
    20% {
      transform: translate3d(0, -10px, 0);
    }

    40%,45% {
      opacity: 1;
      transform: translate3d(0, 20px, 0);
    }

    to {
      opacity: 0;
      transform: translate3d(0, -2000px, 0);
    }
  }

  .rrt-confirm-holder {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99999999;
    .shadow {
      width: 100%;
      height: 100%;
      background-color: rgba(50, 58, 68, 0.8);
    }
    .rrt-confirm {
      width: 320px;
      background-color: white;
      position: absolute;
      z-index: 9;
      top: 20%;
      left: 50%;
      margin-left: -160px;
      box-shadow: 3px 3px 20px #333;
      border-radius: ${radius}px;
      overflow: hidden;
      .rrt-message {
        width: 100%;
        padding: 5%;
        min-height: 50px;
        font-size: 1em;
        background-color: white;
        text-align: center;
        font-family: 'open-sanscondensed-light', sans-serif;
        clear: both;
      }
      .rrt-buttons-holder {
        display: flex;
        .rrt-button {
          flex-grow: 1;
          height: 50px;
          text-transform: capitalize;
          border: none;
          background-color: transparent;
          padding: 0;
          margin: 0;
          float: left;
          border-top: 1px solid #f0f0f0;
          font-size: 14px;
          overflow: hidden;
          cursor: pointer;
          &:hover,
          &:focus,
          &:active {
            color: #FFF;
            background-color: ${colors.red};
          }
          &:first-of-type:hover,
          &:first-of-type:focus,
          &:first-of-type:active {
             background-color: ${colors.lightGreen};
           }
          &.rrt-ok-btn:active {
            background-color: #60bb71;
            color: white;
          }
          &.rrt-cancel-btn:active {
            background-color: #db6a64;
            color: white;
          }
          &:focus {
            outline: none;
          }
        }
      }
    }
  }

  body.toastr-confirm-active {
    overflow: hidden;
  }

  .redux-toastr {
    .top-left, .top-right, .top-center, .bottom-left, .bottom-right, .bottom-center {
      width: 550px;
      position: fixed;
      z-index: 99999999;
      padding: 0 10px;
    }
    .top-left, .top-right, .top-center {
      top: 0;
    }
    .top-right, .bottom-right {
      right: 0;
    }
    .bottom-left, .bottom-right, .bottom-center {
      bottom: 0;
    }
    .top-left, .bottom-left {
      left: 0;
    }
    .top-center, .bottom-center {
      left: 50%;
      margin-left: -175px;
    }
    .toastr {
      background-color: #fcfcfc;
      width: 100%;
      overflow: hidden;
      margin: 10px 0;
      border-radius: ${radius}px;
      position: relative;
      z-index: 2;
      color: #333;
      opacity: 1;
      box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.2);
      & > div {
        display: flex;
        align-items: center;
        padding: ${baseSpacing / 2}px;
        line-height: 1;
      }
      &:hover:not(.rrt-message) {
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.33);
        opacity: 1;
      }
      .toastr-status {
        width: 100%;
        height: 5px;
        &.success {
          background-color: #60bb71;
        }
        &.warning {
          background-color: #f7a336;
        }
        &.info {
          background-color: #58abc3;
        }
        &.error {
          background-color: #dc1c2e;
        }
      }
      .rrt-left-container {
        align-self: center;
        // We need to over-ride the inline dimensions
        .toastr-icon {
          width:24px !important;
          height:24px !important;
          fill: white;
          vertical-align: middle;
        }
      }
      .rrt-middle-container {
        flex-grow: 1;
        margin: 0 ${baseSpacing / 2}px;
        font-family: Arial, Helvetica, sans-serif, sans-serif;
        font-size: 1em;
        line-height: 1.4;
      }
      .rrt-right-container {

      }
      .close-toastr {
        // Hack to hide the default close mark from toastr
        visibility: hidden;

        &:before {
          content: " ";
          visibility: visible;
          background-image: url(${xmark});
          background-size: contain;
          background-position: center;
          position: absolute;
          width: 24px;
          height: 24px;
          top: calc(50% - 12px);
          right: 12px;
          filter: invert(100%) opacity(80%);
          border: 1px solid black;
          cursor: pointer;
        }

        &:hover::before {
          filter: invert(100%) opacity(100%);
        }
      }
      &.rrt-info, &.rrt-success, &.rrt-warning, &.rrt-error {
        color: white;
      }
      &.rrt-info {
        background-color: #58abc3;
        .rrt-progressbar {
          background-color: #378298;
        }
      }
      &.rrt-success {
        background-color: #60bb71;
        .rrt-progressbar {
          background-color: #3e914d;
        }
      }
      &.rrt-warning {
        background-color: #f7a336;
        .rrt-progressbar {
          background-color: #d87e09;
        }
      }
      &.rrt-error {
        background-color: #dc1c2e;
        .rrt-progressbar {
          background-color: #c5352e;
        }
      }
      &.rrt-light {
        .rrt-progressbar {
          background-color: #ccc;
        }
        .toastr-icon {
          fill: #333 !important;
        }
      }
      &.rrt-message {
        opacity: 1;
        border: 1px solid #dbdbdb;
        .rrt-title {
          width: 90%;
          height: 50px;
          text-align: center;
          overflow: hidden;
          font-size: 1.2em;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          line-height: 50px;
          padding: 0 20px;
        }
        .rrt-text {
          width: 100%;
          max-height: 400px;
          overflow: hidden;
          overflow-y: auto;
          border-top: 1px solid #f1f1f1;
          border-bottom: 1px solid #f1f1f1;
          background-color: white;
          padding: 15px;
          font-size: 1.1em;
          margin-bottom: 20px;
          img {
            display: block;
            margin: 10px auto;
            max-width: 100%;
          }
        }
        .close-toastr {
          height: 50px;
        }
      }
      .rrt-progress-container {
        height: 5px;
        margin: 0 -20px -20px -60px;
        position: absolute;
        bottom: 20px;
        width: 100%;
        .rrt-progressbar {
          border-radius: 0 0 0 4px;
          height: 100%;
        }
      }
    }
    .toastr-attention {
      width: 100%;
      height: 100%;
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0, 0, 0, 0.4);
      z-index: 1;
    }
  }

  @media (max-width: 320px) {
    .redux-toastr {
      .top-left, .top-right, .top-center, .bottom-left, .bottom-right, .bottom-center {
        width: 320px;
      }
      .top-center, .bottom-center {
        margin-left: -160px;
      }
    }
  }
`;

export default ToastrStyles;
